/**
 * @module app.collapseDirective
 */
import appBase from './index.js';
import appApplyHelper from './ApplyHelper.js';
import {MAIN_MENU_EVENT_NAME, MENU_TOGGLE_COLLAPSE} from "./constants";

/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
export const appCollapse = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function(scope, element, attrs) {
          var collapser = element;
          collapser.bind('click', function(event) {
            event.preventDefault();
            var target = $(attrs['appCollapse']);
            target.toggleClass('in');
            var toggle = collapser.add(attrs['toggleCollapsed']);
            toggle.toggleClass('collapsed');
          });
        }
  };
};

appBase.directive('appCollapse', appCollapse);


/**
 * @param {jQuery} target
 * @param {string} direction
 * @param {function()=} opt_complete
 * @param {boolean=} opt_no_animation
 * @return {jQuery}
 */
export const directiveToggle = function(target, direction, opt_complete, opt_no_animation) {
  if (opt_no_animation) {
    const ret = target['toggle']();
    if (opt_complete) {
      opt_complete();
    }
    return ret;
  } else {
    return target['toggle']('slide', {'direction': direction}, 200, opt_complete);
  }
};


/**
 * @param {jQuery} target
 * @param {string} direction
 * @param {function()=} opt_complete
 * @param {boolean=} opt_no_animation
 * @return {jQuery}
 */
export const directiveShow = function(target, direction, opt_complete, opt_no_animation) {
  if (opt_no_animation) {
    const ret = target['show']();
    if (opt_complete) {
      opt_complete();
    }
    return ret;
  } else {
    return target['show']('slide', {'direction': direction}, 200, opt_complete);
  }
};


/**
 * @param {jQuery} target
 * @param {string} direction
 * @param {function()=} opt_complete
 * @param {boolean=} opt_no_animation
 * @return {jQuery}
 */
export const directiveHide = function(target, direction, opt_complete, opt_no_animation) {
  if (opt_no_animation) {
    const ret = target['hide']();
    if (opt_complete) {
      opt_complete();
    }
    return ret;
  } else {
    return target['hide']('slide', {'direction': direction}, 200, opt_complete);
  }
};


/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
appBase.collapseMenuDirective = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function(scope, element, attrs) {
          const collapser = element;
          const applyHelper = new appApplyHelper(scope);
          const targetName = attrs['appCollapseMenu'];

          scope.$on(MENU_TOGGLE_COLLAPSE, collapse);
          collapser.bind('click', () => {
            scope.$emit(MENU_TOGGLE_COLLAPSE, targetName);
          });

          function collapse(event, collapseTargetName) {
            if (collapseTargetName !== targetName) {
              return;
            }
            event.preventDefault();

            var focusedElement = $(':focus');
            var target = $(`.${targetName} .menu-item-body`);
            // FIXME: configurable ?
            var toggle = collapser.add('#menu-container');

            if (!target.hasClass('in')) {

              // show the submenu
              directiveHide(target.closest('.menu'), 'left').promise().done(function() {
                target.toggleClass('in');
                toggle.toggleClass('collapsed');

                // hide the other submenus
                $('.menu-item').not(':has(.in)').addClass('hidden');
              }).done(function() {
                directiveShow($('.menu'), 'left');
              }).done(function() {
                // show submenu only when main menu is hidden
                applyHelper.wrapInApplyIfFromDOM(event, function() {
                  scope.$root.$broadcast('submenuChange', {
                    'open': true,
                    'element': element,
                    'dom': applyHelper.isDOMEvent(event)
                  });
                });
                // display button to collapse open sub menu
                $('.menu-button-collapse-sub-menu').removeClass('hidden');
              }).done(function() {
                //Focus the element that was focused before this animation
                focusedElement.focus();
              });
            }
          }
        }
  };
};
appBase.directive('appCollapseMenu', appBase.collapseMenuDirective);

/**
 * @ngInject
 * @return {angular.Directive} The directive specs.
 */
appBase.expandMainMenuDirective = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function(scope, element, attrs) {
          var collapser = element;
          var applyHelper = new appApplyHelper(scope);

          scope.$on(MAIN_MENU_EVENT_NAME.EXPAND, expandMainMenuFunction);
          collapser.bind('click', () => {
            scope.$root.$broadcast(MAIN_MENU_EVENT_NAME.EXPAND);
          });

          function expandMainMenuFunction(event, opts = {no_animation: false}) {
            event.preventDefault();

            collapser.toggleClass('collapsed');
            $('#menu-container').removeClass('collapsed');

            var triggerMainMenuShownEvent = function() {
              applyHelper.wrapInApplyIfFromDOM(event, function() {
                scope.$root.$broadcast(MAIN_MENU_EVENT_NAME.MAIN_MENU_SHOWN);
              });
            };

            var target = $(attrs['appExpandMainMenu']);
            // show main menu
            directiveShow(target, 'left', triggerMainMenuShownEvent, opts.no_animation);

            // hide menu button since menu is expanded
            collapser.addClass('hidden');
          }
        }
  };
};
appBase.directive('appExpandMainMenu', appBase.expandMainMenuDirective);

/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
appBase.collapseMainMenuDirective = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function(scope, element, attrs) {
          var collapser = element;
          var expander = $('.main-menu-expand');
          var applyHelper = new appApplyHelper(scope);

          scope.$on(MAIN_MENU_EVENT_NAME.COLLAPSE, collapseMainMenuFunction);
          collapser.bind('click', () => {
            scope.$root.$broadcast(MAIN_MENU_EVENT_NAME.COLLAPSE);
          });

          function collapseMainMenuFunction(event) {
            event.preventDefault();

            var target = $(attrs['appCollapseMainMenu']);

            // hide main menu
            directiveHide(target, 'left', function() {
              // set main menu as collapsed
              $('#menu-container').addClass('collapsed');

              // after menu has collapsed display menu button
              expander.removeClass('hidden');

              // back to main menu
              if ($('.menu-item.hidden').length > 0) {
                var menu = $('.menu-item').has('.in');
                // hide the displayed submenu
                menu.find('.in').removeClass('in');

                // display all the menus
                $('.menu-item').removeClass('hidden');

                // hide sub menu collapse button
                $('.menu-button-collapse-sub-menu').addClass('hidden');

                // bring back the "+" icon
                var subCollapser = menu.find('[app-collapse-menu]');
                subCollapser.addClass('collapsed');

                // Enter Angular cycle
                applyHelper.wrapInApplyIfFromDOM(event, function() {
                  scope.$root.$broadcast('submenuChange', {
                    'open': false,
                    'element': subCollapser,
                    'dom': applyHelper.isDOMEvent(event)
                  });
                });

              }

            });
          }
        }
  };
};
appBase.directive('appCollapseMainMenu', appBase.collapseMainMenuDirective);

/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
appBase.collapseSubMenuDirective = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function(scope, element, attrs) {
          var collapser = element;
          var applyHelper = new appApplyHelper(scope);

          scope.$on(MAIN_MENU_EVENT_NAME.COLLAPSE_SUB_MENU, collapseSubMenuFunction);
          collapser.bind('click', () => {
            scope.$root.$broadcast(MAIN_MENU_EVENT_NAME.COLLAPSE_SUB_MENU);
          });

          function collapseSubMenuFunction(event, opts = {no_animation: false, showMainMenu: true}) {
            event.preventDefault();
            var toggle = collapser.add(attrs['toggleCollapsed']);
            toggle.toggleClass('collapsed');

            var triggerMainMenuShownEvent = function() {
              applyHelper.wrapInApplyIfFromDOM(event, function() {
                scope.$root.$broadcast(MAIN_MENU_EVENT_NAME.MAIN_MENU_SHOWN);
              });
            };

            var target = $(attrs['appCollapseSubMenu']);

            const afterClose = () => {
              // collapse submenu body and collapser
              var menu = $('.menu-item').has('.in');
              menu.find('.in').removeClass('in');

              var subCollapser = menu.find('[app-collapse-menu]');
              subCollapser.addClass('collapsed');

              // Enter Angular cycle
              applyHelper.wrapInApplyIfFromDOM(event, function() {
                scope.$root.$broadcast('submenuChange', {
                  'open': false,
                  'element': subCollapser,
                  'dom': applyHelper.isDOMEvent(event)
                });
              });

              // if a submenu is hidden (^ button was clicked) show it
              $('.menu-item').css('display', '');

              // show all the submenus
              $('.menu-item').removeClass('hidden');

              // hide sub menu collapse button
              $('.menu-button-collapse-sub-menu').addClass('hidden');

              // show main menu
              if (opts.showMainMenu) {
                directiveShow(target, 'left', triggerMainMenuShownEvent, opts.no_animation);
              }
            };

            // visible submenu; back to main menu
            directiveToggle(target, 'left', afterClose, opts.no_animation);
          }
        }
  };
};
appBase.directive('appCollapseSubMenu', appBase.collapseSubMenuDirective);


/**
 * @return {angular.Directive} The directive specs.
 * @ngInject
 */
appBase.no3dDirective = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} scope Scope.
         * @param {jQuery} element Element.
         * @param {angular.Attributes} attrs Attributes.
         */
        function(scope, element, attrs) {
          var ctrl = /** @type {app.MainController} */ (scope['ctrl']);
          element.bind('click', function(event) {
            if (!ctrl.cesium.not3d()) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          });
        }
  };
};
appBase.directive('no3d', appBase.no3dDirective);


export default appBase.no3dDirective;
